"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Label = _interopRequireDefault(require("./Label"));

require("./Form.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = function _default(_ref) {
  var htmlFor = _ref.htmlFor,
      className = _ref.className,
      label = _ref.label,
      error = _ref.error,
      help = _ref.help,
      optional = _ref.optional,
      optionalLabel = _ref.optionalLabel,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["htmlFor", "className", "label", "error", "help", "optional", "optionalLabel", "children"]);

  return _react.default.createElement("div", {
    className: "vs-field ".concat(className ? className : '')
  }, _react.default.createElement(_Label.default, _extends({}, restProps, {
    htmlFor: htmlFor,
    className: "vs-field-label",
    weight: "bold"
  }), label, ' ', _react.default.createElement("span", {
    className: "vs-field-optional"
  }, optional ? "- ".concat(optionalLabel) : null)), children, error ? _react.default.createElement("div", {
    className: "vs-validation-error"
  }, error) : _react.default.createElement("div", {
    className: "vs-field-help"
  }, help));
};

exports.default = _default;